import React, { useEffect, useRef, useState } from "react";
import EzTable from "../../../common/EzTable";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import EzNotFound from "../../../common/EzNotFound";
import { Box, Container, CircularProgress } from "@mui/material";
import Breadcrumb from "../../../common/Breadcrumb";
import { Button } from "primereact/button";
import { useStyles } from "./style";
import { RentersRentersInfoBreadcrumb } from "../RentersRentersInfo/CreateRentersRentersInfo/constant";

const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
const RentersRentersInfo = (props) => {
  const classes = useStyles();
  const {
    fetchRentersRentersInfos,
    tableData,
    setDeleteConfirmationPopupVisibility,
    exportRentersRentersInfo,
    exportPDFRentersRentersInfo,
    exportCSVRentersRentersInfo,
    isPageLevelError,
    paginationInfo,
    isLoading,
    screenPermissions,
    handleCreateRentersRentersInfo,
    editRentersRentersInfoRoute,
  } = props;

  const [isCopy, setIsCopy] = useState(false);
  const [areFiltersVisible, toggleFilterState] = useState(true);
  const convertToTSV = (data) => {
    const headers = data.columns.map((item) => item.colLabel).join("\t");
    //const headers = Object.keys(data.rows[0]).join('\t');
    const rows = data.rows
      .map((row) => Object.values(row).join("\t"))
      .join("\n");
    return `${headers}\n${rows}`;
  };

  const copyToClipboard = () => {
    const csv = convertToTSV(tableData);
    navigator.clipboard
      .writeText(csv)
      .then(() => setIsCopy(true))
      .catch((err) => setIsCopy(true));
  };
  useEffect(() => {
    setTimeout(() => setIsCopy(false), 1000);
  }, [isCopy]);
  const tableRef = useRef();
  const handlePrint = () => {
    const printContents = tableRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };
  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">Renters Info</h4>
            <Button
              label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
              icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
              className={`p-button-text p-button-secondary`}
              onClick={() => {
                toggleFilterState(!areFiltersVisible);
              }}
            />
          </div>
          <div className="buttonarea">
            <div className="create-btn-group">
              <Button
                label={"Copy"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={copyToClipboard}
              />
              <Button
                label={"Excel"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={exportRentersRentersInfo}
              />
              <Button
                label={"CSV"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={exportCSVRentersRentersInfo}
              />
              <Button
                label={"PDF"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={exportPDFRentersRentersInfo}
              />
              <Button
                label={"Print"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={handlePrint}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderComplianceRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderComplianceRecords() && !shouldRenderFullPageError() && !isLoading;
  const shouldRenderLoader = () => isLoading && !shouldRenderComplianceRecords();
  const filters = {
    global: { value: null },
    firstName: { value: null, filterKey: "firstName" },
    lastName: { value: null, filterKey: "lastName" },
    emailId: { value: null, filterKey: "emailId" },
    contactNumber: { value: null, filterKey: "contactNumber" },
    address: { value: null, filterKey: "address" },
    nameOnCard: { value: null, filterKey: "nameOnCard" },
    creditCardNumber: { value: null, filterKey: "creditCardNumber" },
    cvv: { value: null, filterKey: "cvv" },
    expiry: { value: null, filterKey: "expiry" },
    flightSpecial: { value: null, filterKey: "flightSpecial" },
    createdBy: { value: null, filterKey: "createdBy" },
    createdTime: { value: null, filterKey: "createdTime" },
    modifiedTime: { value: null, filterKey: "modifiedTime" },
    modifiedBy: { value: null, filterKey: "modifiedBy" },
    status: { value: null, filterKey: "status" },
  };

  const getToastProps = () => {
    let toastTitle = "";
    if (isCopy) {
      let toastTitle = "Data copied to clipboard!";
      if (!isCopy) {
        toastTitle = "Error while Data copied to clipboard!";
      }

      return {
        severity: isCopy ? TOAST_SEVERITY.SUCCESS : TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const tableProps = {
    columns: tableData?.columns,
    paginationInfo,
    areFiltersVisible,
    screenPermissions,
    value: tableData?.rows,
    emptyMessage: "No Renters Info found.",
    filters,
    loadLazyData: fetchRentersRentersInfos,
    loading: isLoading,
    showMoreActions: false,
    sortField: null,
    setDeleteConfirmationPopupVisibility,
    onEditRecord: editRentersRentersInfoRoute,
    showViewButton: false,
    showCopyButton: false,
    showDeleteButton: false,
    showEditButton: false,
  };
  return (
    <>
      <Container maxWidth="lg">
        <Breadcrumb list={RentersRentersInfoBreadcrumb} />
        <EzToast {...getToastProps()} />
        <div className={`containerbox ${classes.bg}`}>
          {renderPageHeaderSection()}
          <div className="mTop15">
            {shouldRenderLoader() && (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="200px"
              >
                <CircularProgress size={30} />
              </Box>
            )}
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderComplianceRecords() && (
              <Box ref={tableRef} id="printable">
                <EzTable {...tableProps} />
              </Box>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No Renters Info records to show"}
              />
            )}
          </div>
        </div>
      </Container>
    </>
  );
};
export default RentersRentersInfo;
